import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import i18n from 'localization/i18nextConf';
import { I18nextProvider } from 'react-i18next';
import App from './App.tsx';
import 'bootstrap/dist/css/bootstrap.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'assets/scss/index.scss';
import { HelmetProvider } from 'react-helmet-async';

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
	<HelmetProvider>
		<BrowserRouter basename={import.meta.env.VITE_APP_BASE_URL}>
			<I18nextProvider i18n={i18n}>
				<QueryClientProvider client={queryClient}>
					<App />
				</QueryClientProvider>
			</I18nextProvider>
		</BrowserRouter>
	</HelmetProvider>,
);
